import React from "react";

const VideotronLogo = () => {
  return (
    <svg
      width="156"
      height="48"
      viewBox="0 0 156 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4287_577)">
        <path d="M48 0H0V48H48V0Z" fill="#FFD200" />
        <path
          d="M12.9664 12.3185L36.1868 23.8651L12.9385 35.6799L27.8918 23.9008L12.9664 12.3185Z"
          fill="black"
        />
      </g>
      <path
        d="M66.7851 29.1508H64.655L61.2378 18.7546H63.1795L65.7296 26.8038L68.2953 18.7546H70.2186L66.7851 29.1508Z"
        fill="black"
      />
      <path
        d="M72.4351 29.1508V18.7546H74.2556V29.1508H72.4351Z"
        fill="black"
      />
      <path
        d="M84.2247 27.6207C83.8669 28.0944 83.4334 28.5056 82.9418 28.8376C82.6251 29.0243 82.2682 29.1317 81.9012 29.1508H77.1509V18.7546H81.9012C82.2734 18.7578 82.638 18.8598 82.9581 19.0501C83.4337 19.4099 83.8544 19.8373 84.207 20.3189C84.4035 20.6103 84.5007 20.9577 84.484 21.3091V26.6297C84.4965 26.9784 84.4063 27.3231 84.2247 27.6207ZM81.7801 27.4119C81.7801 27.4119 81.8842 27.4119 81.9012 27.3948C82.1442 27.2527 82.6642 26.8038 82.6642 26.5949V21.3624C82.6642 21.3327 82.6584 21.3032 82.6472 21.2757C82.4582 20.9625 82.1964 20.6997 81.8842 20.5099C81.8338 20.4948 81.7809 20.489 81.7284 20.4929H78.9721V27.4126L81.7801 27.4119Z"
        fill="black"
      />
      <path
        d="M87.3774 29.1508V18.7546H93.8945V20.4929H89.1958V23.1213H93.5637V24.8595H89.1951V27.4168H93.8938V29.1558L87.3774 29.1508Z"
        fill="black"
      />
      <path
        d="M104.176 27.6732C103.812 28.145 103.386 28.5659 102.911 28.9249C102.585 29.1192 102.215 29.2268 101.835 29.2374H99.2003C98.8207 29.2294 98.4499 29.1216 98.1249 28.9249C97.6454 28.5709 97.2192 28.1493 96.8598 27.6732C96.6699 27.3771 96.5732 27.0306 96.5821 26.6787V21.2373C96.5738 20.8868 96.6705 20.5419 96.8598 20.2471C97.2191 19.7708 97.6452 19.3492 98.1249 18.9954C98.4499 18.7984 98.8207 18.6904 99.2003 18.6821H101.835C102.215 18.693 102.585 18.8008 102.911 18.9954C103.386 19.3542 103.812 19.7752 104.176 20.2471C104.365 20.5419 104.461 20.8869 104.453 21.2373V26.6787C104.462 27.0306 104.366 27.3771 104.176 27.6732ZM98.4033 26.6645C98.4033 26.6645 98.4033 26.7164 98.4203 26.7355C98.624 27.0318 98.8831 27.2856 99.1833 27.4828C99.2103 27.4952 99.2399 27.5011 99.2697 27.4999H101.766C101.796 27.4998 101.825 27.494 101.852 27.4828C102.153 27.2858 102.412 27.032 102.615 26.7355C102.626 26.7133 102.632 26.6891 102.632 26.6645V21.2927C102.632 21.2927 102.632 21.2217 102.615 21.2061C102.412 20.9047 102.153 20.6448 101.852 20.4403C101.825 20.4281 101.796 20.4222 101.766 20.4232H99.2697C99.2697 20.4232 99.1988 20.4232 99.1833 20.4403C98.8831 20.645 98.6242 20.9048 98.4203 21.2061C98.4093 21.2336 98.4035 21.263 98.4033 21.2927V26.6645Z"
        fill="black"
      />
      <path
        d="M110.762 20.4929V29.1508H108.942V20.4929H106.134V18.7546H113.572V20.4929H110.762Z"
        fill="black"
      />
      <path
        d="M122.92 23.7442C122.644 24.0862 122.33 24.3959 121.984 24.6677C121.848 24.772 121.695 24.854 121.533 24.9107L123.596 29.1508H121.62L119.696 25.0506H117.702V29.1537H115.882V18.7546H120.753C121.192 18.7586 121.62 18.8915 121.984 19.1368C122.331 19.42 122.644 19.7407 122.92 20.093C123.125 20.4085 123.234 20.7771 123.233 21.1535V22.683C123.236 23.06 123.127 23.4295 122.92 23.7442ZM121.413 21.1713C121.414 21.1301 121.408 21.0891 121.395 21.0498C121.292 20.8587 121.014 20.5107 120.841 20.4929H117.703V23.3095H120.754C120.91 23.3095 121.257 22.9792 121.395 22.7362C121.406 22.7141 121.412 22.6899 121.413 22.6652V21.1713Z"
        fill="black"
      />
      <path
        d="M133.518 27.6732C133.154 28.1451 132.728 28.5661 132.253 28.9249C131.927 29.1192 131.557 29.2268 131.178 29.2374H128.543C128.163 29.2294 127.792 29.1216 127.467 28.9249C126.988 28.571 126.561 28.1495 126.202 27.6732C126.012 27.3771 125.915 27.0306 125.924 26.6787V21.2373C125.916 20.8868 126.013 20.5419 126.202 20.2471C126.561 19.7707 126.987 19.3491 127.467 18.9954C127.792 18.7984 128.163 18.6904 128.543 18.6821H131.178C131.557 18.693 131.927 18.8008 132.253 18.9954C132.729 19.3541 133.154 19.775 133.518 20.2471C133.707 20.5419 133.804 20.8868 133.796 21.2373V26.6787C133.805 27.0306 133.708 27.3771 133.518 27.6732ZM127.746 26.6645C127.746 26.6645 127.746 26.7164 127.763 26.7355C127.966 27.0318 128.225 27.2855 128.525 27.4828C128.552 27.4953 128.582 27.5012 128.612 27.4999H131.108C131.138 27.4998 131.167 27.494 131.195 27.4828C131.495 27.2858 131.754 27.032 131.958 26.7355C131.968 26.7133 131.974 26.6891 131.975 26.6645V21.2927C131.975 21.2927 131.975 21.2217 131.958 21.2061C131.754 20.9047 131.495 20.6448 131.195 20.4403C131.168 20.428 131.138 20.4222 131.108 20.4232H128.612C128.612 20.4232 128.541 20.4232 128.525 20.4403C128.225 20.645 127.966 20.9049 127.763 21.2061C127.751 21.2336 127.746 21.263 127.746 21.2927V26.6645Z"
        fill="black"
      />
      <path
        d="M141.914 29.1508L138.325 22.2489V29.1508H136.505V18.7546H138.464L142.018 25.7432V18.7546H143.838V29.1508H141.914Z"
        fill="black"
      />
      <path
        d="M93.104 15.9863H91.1163L89.8022 17.6912H91.4591L93.104 15.9863Z"
        fill="black"
      />
      <defs>
        <clipPath id="clip0_4287_577">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default VideotronLogo;
